/**
 * @file 資料の索引 (語 → 紙のページ番号) のクライアント。
 * @what: `GET /families/{familyId}/study/sources/{sourceId}/index`。索引が無い資料は空配列。
 * @why: 資料どうしの対応づけ (StudySource.related) は、相手の目次の見出しとこの索引の語に
 *   突き合わせて引く (model/sourceLinks.ts)。本だなの一覧に埋めると重いので、資料を
 *   開いたときだけ取る。
 * @failure: ApiError を伝播。空配列 = 索引を取り込んでいない、は正常系。
 */

import { apiFetch } from "@/shared/api/client";

export interface StudySourceIndexEntry {
  term: string;
  /** 紙のページ番号 (1 始まり)。同じ語が複数のページを指すときは 1 行ずつ並ぶ。 */
  page: number;
}

export async function fetchSourceIndex(
  familyId: string,
  sourceId: string,
  signal?: AbortSignal,
): Promise<StudySourceIndexEntry[]> {
  const res = await apiFetch<{ entries: StudySourceIndexEntry[] }>(
    `/families/${encodeURIComponent(familyId)}/study/sources/${encodeURIComponent(sourceId)}/index`,
    signal ? { signal } : {},
  );
  return res.entries;
}
